import { Form } from "@/components/form";
import { Stack, StackProps, Typography } from "@mui/material";

export default function ArticuloImageFormFields({
    ...props
}: StackProps) {
    return <Stack gap={2} {...props}>
        <Typography variant="h6">Imagen</Typography>
        <Form.ImageField minHeight={"250px"} name="imagen" />
    </Stack>
}